export function undefinedCheck(value: string | undefined) {
	if (value === undefined || value === null || value.trim() === '') {
		return <i>Undefined</i>;
	}

	return <>{value}</>;
}
